import { TalentPicksDefaultMessages } from "../types";

export const talentPicksDefaultMessages: TalentPicksDefaultMessages = {
  title: "FDTV Picks",
  picksResulted: "Resulted Races",
  emptyState: {
    title: "No FDTV picks available",
    description: "There are no picks available for today"
  },
  trackFilter: {
    filterLabel: "Track",
    selectedValue: "",
    selectedLabel: "All Tracks"
  },
  expertFilter: {
    filterLabel: "Expert",
    selectedValue: "",
    selectedLabel: "All Experts"
  },
  tool: {
    alert: {
      title: "Talent Picks Tool.",
      description: "You can create or disable FDTV Picks for today here."
    },
    myPicksFilter: "My FDTV Picks",
    toolBar: {
      description: "Create an FDTV Pick from the selections.",
      cancelButton: "Cancel",
      createButton: "Create FDTV Pick"
    },
    talentsModal: {
      title: "Create FDTV Pick on behalf of:",
      selectButton: "Select",
      cancelButton: "Cancel"
    },
    createModal: {
      title: "Create FDTV Pick",
      wagerTypeSelector: {
        empty: "This pick has started. No bets available for this leg."
      }
    },
    confirmModal: {
      title: "Confirm FDTV Pick",
      success: {
        title: "FDTV Pick Created"
      },
      checkboxLabel: "Don't show me confirmation step again",
      errorMessage:
        "Sorry we cannot confirm your FDTV Pick card. Please try again in a few minutes.",
      returnButton: "Return to Race",
      retainButton: "Retain Runners",
      syncToastText:
        "Talent Picks may take a moment to update, we appreciate your patience"
    }
  }
};
